import {
  Gym,
  Exercise,
  Member,
  Trainer,
  Muscle,
  TrainingRoutineTemplate,
  Manager,
  GymProduct,
  Program,
  Group,
} from '../types';

export interface TrainerDashboardData {
  trainer: Trainer;
  members: Record<string, Member>;
  groups: Record<string, Group>;
  personalizedExercises: Record<string, Exercise>;
  templates: Record<string, TrainingRoutineTemplate>;
  programs: Record<string, Program>;
}

export interface GymDashboardData {
  gym: Gym;
  managers: Record<string, Manager>;
  trainers: Record<string, TrainerDashboardData>;
  unassignedMembers: Record<string, Member>;
  gymProducts: GymProduct[];
}

export interface AppState {
  loginManagerId: string | null;
  loginTrainerId: string | null;
  loginMemberId: string | null;
  selectedGymId: string | null;
  exercises: Record<string, Exercise>;
  muscles: Record<string, Muscle>;
  gymDataMap: Record<string, GymDashboardData>;
}

export const getAppInitialState = (): AppState => ({
  loginManagerId: null,
  loginTrainerId: null,
  loginMemberId: null,
  selectedGymId: null,
  gymDataMap: {},
  exercises: {},
  muscles: {},
});
